module.exports = __webpack_public_path__ + "static/media/BlueArrowDown.3b6d187d.svg";